// extracted by mini-css-extract-plugin
export default {"shopPanel":"shop_panel__shopPanel--LTOy","shopPanelContent":"shop_panel__shopPanelContent--txUC","shopHeading":"shop_panel__shopHeading--DYBL"};